import React, { useState, useEffect } from "react";
import axios from "axios";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import Loader from "../../Common/Loader";
import { Constants } from "../../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import SmallLoader from "../../Common/smallLoader";

function Holdings(props) {
  //destructuring apply
  const {holdingData,loader,commonError,totalValue}=props
  const {
    Holdings,
    Stock_Symbol,
    Total_Qty,
    Avg_Cost_Price,
    LTP,
    Invested_Value,
    Current_Value,
    pnl_value,
    pnl_percent,
    clientId,
    Total,

  } = Constants;

  //destructuring apply end

  // const storeToken = localStorage.getItem("ssoToken");
  // const [holdingData, setHoldingData] = useState([]);
  // const [loader, setLoader] = useState(false);
  // const [commonError, setCommonError] = useState(false);
  // const [totalValue, setTotalValues] = useState({
  //   totalCurrent: 0,
  //   totalInvest: 0,
  //   totalPnl: 0,
  //   totalPnlPer: 0,
  // });
  // const [smallLoaderPdf, setPdfLoader] = useState(false);
  // const [smallLoaderExcel, setExcelLoader] = useState(false);

  // const getHoldingTableData = async (viewType = "grid") => {
  //   let clientCode = "";
  //   if (localStorage.getItem("clientCode")) {
  //     clientCode = localStorage.getItem("clientCode");
  //   }
  //   if (viewType === "grid") {
  //     setLoader(true);
  //   }

  //   if (viewType === "pdf") {
  //     setPdfLoader(true);
  //   }
  //   if (viewType === "excel") {
  //     setExcelLoader(true);
  //   }
  //   let payloadValue = { ClientCode: clientCode, fileType: viewType };
  //   let encPayload = AESEncryption(payloadValue);
  //   try {
  //     const getHoldingData = await axios.post(
  //       DASHBOARD_CLIENT_DETAIL_EQUITY.Holdings_URL,

  //       `"${encPayload}"`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${storeToken}`,
  //           reserv: 1,
  //         },
  //       }
  //     );
  //     const res = ApiResDecrypt(getHoldingData?.data);
  //     console.log("response holding",res)
  //     if (res?.status === 0) {
  //       if (viewType === "grid") {
  //         setCommonError(false);
  //         // setHoldingData(res?.data?.hold); //old api 
  //         setHoldingData(res?.data);
  //         setTotalValues({
  //           totalCurrent: res?.data?.totalCurrent,
  //           totalInvest: res?.data?.totalInvest,
  //           totalPnl: res?.data?.totalPnl,
  //           totalPnlPer: res?.data?.totalPnlPer,
  //         });
  //       }

  //       if (viewType === "excel") {
  //         window.open(res?.data, "_self", "noopener,noreferrer");
  //       }
  //       if (viewType === "pdf") {
  //         window.open(res?.data, "_blank", "noopener,noreferrer");
  //       }
  //     } else {
  //       if (viewType !== "grid") {
  //         toast.error(res?.message);
  //       } else {
  //         setHoldingData([]);
  //         setCommonError(res?.message);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setCommonError(error?.message);
  //   } finally {
  //     setLoader(false);
  //     setExcelLoader(false);
  //     setPdfLoader(false);
  //   }
  // };
  // console.log("holdingData",holdingData)
  // useEffect(() => {
  //   getHoldingTableData("grid");
  // }, []);

  // const handleOnClick = (e) => {
  //   if (e.target.value) {
  //     getHoldingTableData(e.target.value);
  //   }
  // };

  return (
    // <div className="holding-comp-card">
      <div >
        <div className="holdings__title card-title d-flex justify-content-between">
          {/* <div className="figure-inlac">
            <h2 className="small-title">{Holdings}</h2>
            {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
          {/* </div>  */}
          {/* <div className="btn-wrapper-summary">
            <button
              value="excel"
              onClick={handleOnClick}
              className="summary-btn excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  Excel
                </>
              )}
            </button>
            <button
              className="summary-btn pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  PDF
                </>
              )}
            </button>
          </div> */}
        </div>
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : (
          <div className="holdings__table scroll-table">
            {holdingData && holdingData.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    {/* <th scope="col">{clientId}</th> */}
                    <th scope="col">{Stock_Symbol}</th>
                    <th scope="col">{Total_Qty}</th>
                    <th scope="col">{Avg_Cost_Price}</th>
                    <th scope="col">{LTP}</th>
                    <th scope="col">{Invested_Value}</th>
                    <th scope="col">{Current_Value}</th>
                    <th scope="col">Today's P&L</th>
                    <th scope="col">{pnl_value}</th>
                  </tr>
                </thead>

                <tbody>
                  {holdingData &&
                    holdingData.map((info, key) => {
                      const {
                        clientId,
                        sym,
                        qty,
                        avgPrice,
                        ltp,
                        invested,
                        value,
                        pnl,
                        todaysPnl,
                      } = info;
                      return (
                        <tr key={key}>
                          {/* <td>{clientId || "-"}</td> */}
                          <td>{sym || "-"}</td>
                          <td>{qty || 0}</td>
                          <td>{avgPrice || 0}</td>
                          <td>{ltp || 0}</td>
                          <td>{invested ? numDifferentiation(invested) : 0}</td>
                          <td>{value ? numDifferentiation(value) : 0}</td>
                          <td>
                            <span
                              className={
                               
                                todaysPnl == 0
                                  ? "text-muted"
                                  : todaysPnl < 0
                                  ? "red-txt"
                                  : "green-txt"
                              }
                            >
                              {numDifferentiation(todaysPnl) || 0}
                            </span>
                          </td>
                          <td>
                            <span
                              className={
                                pnl == 0
                                  ? "text-muted"
                                  : pnl < 0
                                  ? "red-txt"
                                  : "green-txt"
                              }
                            >
                              {pnl ? numDifferentiation(pnl) : 0.00}
                            </span>
                          </td>
                        
                        </tr>
                      );
                    })}
                </tbody>

                <tbody className="total-holdings">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">{Total}</th>
                    <th scope="col">
                      {totalValue?.totalInvest
                        ? numDifferentiation(totalValue?.totalInvest)
                        : 0}
                    </th>

                    <th scope="col">
                      {totalValue?.totalCurrent
                        ? numDifferentiation(totalValue?.totalCurrent)
                        : 0}
                    </th>
                    <th
                      scope="col"
                      className={
                        totalValue?.todaysPnl === 0
                          ? "gray-text"
                          : totalValue?.todaysPnl > 0
                          ? "green-txt"
                          : "red-txt"
                      }
                    >
                      {totalValue?.todaysPnl
                        ? numDifferentiation(totalValue?.todaysPnl)
                        : 0}
                    </th>
                    <th
                      scope="col"
                      className={
                        totalValue?.pnl === 0
                          ? "gray-text"
                          : totalValue?.pnl > 0
                          ? "green-txt"
                          : "red-txt"
                      }
                    >
                      {console.log("todaysPnl",totalValue?.pnl)}
                      {totalValue?.pnl? numDifferentiation(totalValue?.pnl) : 0.00} 
                    </th>
                  </tr>
                </tbody>
              </table>
            ) : (
              commonError && (
                <h4 className="no-data">{noDataFound(commonError)}</h4>
              )
            )}
          </div>
        )}
      </div>
    // </div>
  );
}

export default Holdings;
